/* eslint-disable import/no-extraneous-dependencies */
// Icons are not dev dependencies

/**
 * https://marella.me/material-symbols/demo/
 * Used svg version because svg are more flexible and can be styled with css,
 * besides each icon can be imported individually to reduce the bundle size.
 */

import AttachMoneySVG from '@material-symbols/svg-400/outlined/attach_money.svg?react';
import BathtubSVG from '@material-symbols/svg-400/outlined/bathtub.svg?react';
import CalendarTodaySVG from '@material-symbols/svg-400/outlined/calendar_today.svg?react';
import CheckSVG from '@material-symbols/svg-400/outlined/check.svg?react';
import CheckCircleSVG from '@material-symbols/svg-400/outlined/check_circle.svg?react';
import ChevronBackSVG from '@material-symbols/svg-400/outlined/chevron_backward.svg?react';
import ChevronForwardSVG from '@material-symbols/svg-400/outlined/chevron_forward.svg?react';
import CloseSVG from '@material-symbols/svg-400/outlined/close.svg?react';
import DeviceThermostatSVG from '@material-symbols/svg-400/outlined/device_thermostat.svg?react';
import DirectionsCarSVG from '@material-symbols/svg-400/outlined/directions_car.svg?react';
import FenceSVG from '@material-symbols/svg-400/outlined/fence.svg?react';
import FlatwareSVG from '@material-symbols/svg-400/outlined/flatware.svg?react';
import FlightSVG from '@material-symbols/svg-400/outlined/flight.svg?react';
import GroupsSVG from '@material-symbols/svg-400/outlined/groups.svg?react';
import KingBedSVG from '@material-symbols/svg-400/outlined/king_bed.svg?react';
import KitchenSVG from '@material-symbols/svg-400/outlined/kitchen.svg?react';
import LanguageSVG from '@material-symbols/svg-400/outlined/language.svg?react';
import LocalParkingSVG from '@material-symbols/svg-400/outlined/local_parking.svg?react';
import LocationOnSVG from '@material-symbols/svg-400/outlined/location_on.svg?react';
import MenuSVG from '@material-symbols/svg-400/outlined/menu.svg?react';
import MountainFlagSVG from '@material-symbols/svg-400/outlined/mountain_flag.svg?react';
import PartilyCloudyDaySVG from '@material-symbols/svg-400/outlined/partly_cloudy_day.svg?react';
import PoolSVG from '@material-symbols/svg-400/outlined/pool.svg?react';
import PrintSVG from '@material-symbols/svg-400/outlined/print.svg?react';
import SearchSVG from '@material-symbols/svg-400/outlined/search.svg?react';
import ShieldSVG from '@material-symbols/svg-400/outlined/shield.svg?react';
import WifiSVG from '@material-symbols/svg-400/outlined/wifi.svg?react';
import WineBarSVG from '@material-symbols/svg-400/outlined/wine_bar.svg?react';
import AddSVG from '@material-symbols/svg-400/rounded/add.svg?react';
import CircleSVG from '@material-symbols/svg-400/rounded/circle.svg?react';
import InfoSVG from '@material-symbols/svg-400/rounded/info.svg?react';
import ClockSVG from '@material-symbols/svg-400/rounded/nest_clock_farsight_analog-fill.svg?react';
import StarSVG from '@material-symbols/svg-400/rounded/star-fill.svg?react';
import React from 'react';

import type { SVGProps } from 'react';

const ICON_SIZES = {
  '2xs': '0.625em',
  xs: '0.75em',
  sm: '0.875em',
  md: '1em',
  lg: '1.25em',
  xl: '1.5em',
  '2xl': '2em',
  '3xl': '3em',
  '4xl': '4em',
  '5xl': '5em',
} as const;

export type IconSize = keyof typeof ICON_SIZES;

type IconProps = SVGProps<SVGSVGElement> & {
  size?: IconSize;
};

export function ClimateIcon({ size = 'md', ...props }: IconProps) {
  return <PartilyCloudyDaySVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function ChevronForwardIcon({ size = 'md', ...props }: IconProps) {
  return <ChevronForwardSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function ChevronDownIcon({ size = 'md', ...props }: IconProps) {
  return (
    <ChevronForwardSVG
      width={ICON_SIZES[size]}
      height={ICON_SIZES[size]}
      style={{ transform: 'rotate(90deg)' }}
      {...props}
    />
  );
}

export function ChevronBackIcon({ size = 'md', ...props }: IconProps) {
  return <ChevronBackSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function CircleIcon({ size = 'md', ...props }: IconProps) {
  return <CircleSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function GroupsIcon({ size = 'md', ...props }: IconProps) {
  return <GroupsSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function MountainIcon({ size = 'md', ...props }: IconProps) {
  return <MountainFlagSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function DollarIcon({ size = 'md', ...props }: IconProps) {
  return <AttachMoneySVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function LanguageIcon({ size = 'md', ...props }: IconProps) {
  return <LanguageSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function TemperatureHalfIcon({ size = 'md', ...props }: IconProps) {
  return <DeviceThermostatSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function UtensilsIcon({ size = 'md', ...props }: IconProps) {
  return <FlatwareSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function ShieldIcon({ size = 'md', ...props }: IconProps) {
  return <ShieldSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function PlaneIcon({ size = 'md', ...props }: IconProps) {
  return <FlightSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function WifiIcon({ size = 'md', ...props }: IconProps) {
  return <WifiSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function SwimmingPoolIcon({ size = 'md', ...props }: IconProps) {
  return <PoolSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function WineGlassIcon({ size = 'md', ...props }: IconProps) {
  return <WineBarSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function SquareParkingIcon({ size = 'md', ...props }: IconProps) {
  return <LocalParkingSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function CloseIcon({ size = 'md', ...props }: IconProps) {
  return <CloseSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function KitchenSetIcon({ size = 'md', ...props }: IconProps) {
  return <KitchenSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function FenceIcon({ size = 'md', ...props }: IconProps) {
  return <FenceSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function BathIcon({ size = 'md', ...props }: IconProps) {
  return <BathtubSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function MenuIcon({ size = 'md', ...props }: IconProps) {
  return <MenuSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function CarIcon({ size = 'md', ...props }: IconProps) {
  return <DirectionsCarSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function HotelIcon({ size = 'md', ...props }: IconProps) {
  return <KingBedSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function CheckIcon({ size = 'md', ...props }: IconProps) {
  return <CheckSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function CircleCheckIcon({ size = 'md', ...props }: IconProps) {
  return <CheckCircleSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function AddIcon({ size = 'md', ...props }: IconProps) {
  return <AddSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function CalendarIcon({ size = 'md', ...props }: IconProps) {
  return <CalendarTodaySVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function LocationDotIcon({ size = 'md', ...props }: IconProps) {
  return <LocationOnSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function SearchIcon({ size = 'md', ...props }: IconProps) {
  return <SearchSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function PrintIcon({ size = 'md', ...props }: IconProps) {
  return <PrintSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function StarIcon({ size = 'md', ...props }: IconProps) {
  return <StarSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function ClockIcon({ size = 'md', ...props }: IconProps) {
  return <ClockSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}

export function InfoIcon({ size = 'md', ...props }: IconProps) {
  return <InfoSVG width={ICON_SIZES[size]} height={ICON_SIZES[size]} {...props} />;
}
